import { Component } from '@angular/core';

@Component({
  selector: 'app-administration',
  template: '<router-outlet></router-outlet>',
  styles: []
})

export class AdministrationComponent {

}
